import { selectProfile } from "@/src/auth/store/auth.selectors";
import type { ProfileRow } from "@/src/auth/types/auth.types";
import { useAppSelector } from "@/src/common/redux/store";

export function useCurrentUser(): ProfileRow | null {
	return useAppSelector(selectProfile);
}
